<script setup lang="ts">
import { CardProps } from "./Card.props"

defineProps<CardProps>()
</script>

<template>
  <div class="brand-product-category-carousel h-full w-[242px] md:w-auto">
    <AppLink :to="path" class="cursor-pointer">
      <div
        class="
          flex
          h-full
          cursor-pointer
          flex-col
          gap-2
          rounded-lg
          bg-white
          px-2
          pb-8
          pt-2
          shadow-01
        "
      >
        <UtilsWrapperImage
          v-if="image"
          v-bind="image"
          :key="image.image.url"
          class="
            wrapper-image-fixed-160 wrapper-image-auto-container-centered
            overflow-hidden
            rounded-lg
          "
        />

        <p v-if="title" class="beaver-bold md:pig-bold">
          {{ title }}
        </p>

        <p v-if="description" class="mouse">
          {{ description }}
        </p>
      </div>
    </AppLink>
  </div>
</template>
